import commonStyles from 'common/commonStyles';

export const centraliseContent = (condition = true): string => {
  return condition ? commonStyles.centralise : '';
};
